import { useNavigate } from "react-router-dom";
import { comics } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";
import SectionTitle from "@/components/feature/SectionTitle";

export default function RecommendedSection() {
  const navigate = useNavigate();
  const picks = comics.filter((c) => c.isRecommend).slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-14 md:py-16">
      <div className="container-x">
        <SectionTitle
          kicker="编辑推荐"
          title="值得收藏的宝藏作品"
          desc="编辑团队从数千部古风国漫中精选的宝藏之作，画风、剧情、人设俱佳。"
          action={
            <button
              onClick={() => navigate("/category")}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600 cursor-pointer"
            >
              更多推荐<i className="ri-arrow-right-line text-xs"></i>
            </button>
          }
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {picks.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}